import React, { useEffect, useState } from 'react';
import { ReactComponent as UserIcon } from '../../Assets/Icons/usernamicon.svg';
import { ReactComponent as EmailIcon } from '../../Assets/Icons/Emailiconwhite.svg';
import { ReactComponent as CompanyNameIcon } from '../../Assets/Icons/companyname.svg';
import { ReactComponent as CompanyAddressIcon } from '../../Assets/Icons/companyaddress.svg';
import { ReactComponent as PasswordIcon } from '../../Assets/Icons/passwordicon.svg';
import { ReactComponent as PhoneIcon } from '../../Assets/Icons/phoneicon.svg';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as HomeAbstract } from '../../Assets/Images/homeabstract.svg';
import OtpVerification from './OtpVerification';
import { default as OtpLoginVerification } from '../Login/OtpVerification';

import { useDispatch, useSelector } from 'react-redux';
import {
  handleEmployeeEmailRequest,
  // handleEmployeeLoginRequest, handleLoginRequest,
  handleRegisterRequest,
  resetOtpState,
} from '../../Storeredux/actions';
import { RootState } from '../../Storeredux/reducers/rootReducer';
import { Auth } from '../../Storeredux/constants/actionTypes';
import CustomButton from '../Form/CustomButton';
import { areAllKeysFilled } from '../../Utils/formValidator';
import { Eye, EyeSlash } from 'iconsax-react';
import UpdateEmployee from '../Login/updateEmployee';

function CooperateSignUp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const AuthState = useSelector((state: RootState) => state.auth as Auth);
  const { loading, next, employeeCreateSteps } = AuthState;
  const location = useLocation();
  const userData = location.state?.userData;
  // const [, setEmployeeCreateSteps] = useState('');
  console.log('uswrvg', userData, next);
  const [data, setData] = useState({
    'company_name' : '',
    'password' : '',
    'company_address' : '',
    'email' : '',
    'company_email_structure' : '',
    'admin_name' : '',
    'bvn': '',
    'phone_number' : '0',
    'alternative_email' : '',
    'alternative_phone' : '',
  });
  // const [employeeRegister, setEmployeeRegister] = useState(false);
  const [employeeData, setEmployeeData] = useState({
    email: '',
  });
  const [errorState, setErrorState] = useState({
    name: '',
    email: '',
    registerEmail: '',
    phone: '',
    alternative_phone: '',
    email_structure: '',
    bvn: '',
  });

  const validateRegisterEmail = (email: string) => {
    // Regular expression for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    console.log(email);
    if (emailRegex.test(email)) {
      console.log(email);
      setEmployeeData({ ...data, email: email });
      setErrorState({ ...errorState, registerEmail: '' });
    } else {
      setEmployeeData({ ...data, email: '' });
      setErrorState({ ...errorState, registerEmail: 'Invalid email address' });
    }
  };

  const validatePhoneNumber = (phoneNumber: string) => {
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    setData({ ...data, phone_number: digitsOnly });
    const expectedLength = 11;
    if (digitsOnly.length === expectedLength) {
      setData({ ...data, phone_number: phoneNumber });
      setErrorState({ ...errorState, phone: '' });
    } else {
      setErrorState({ ...errorState, phone: 'Invalid Phone Number' });
    }
  };

  const validateFullName = (fullname: string) => {
    const names = fullname.trim().split(' ').filter(Boolean); // Remove empty strings
    if (names.length < 2) {
      setData({ ...data, admin_name: '' });
      setErrorState({ ...errorState, name: 'Please enter both last name and first name.' });
    } else {
      setData({ ...data, admin_name: fullname });
      setErrorState({ ...errorState, name: '' });

    }
  };

  const validateBvn = (phoneNumber: string) => {
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    setData({ ...data, bvn: digitsOnly });
    const expectedLength = 11;
    if (digitsOnly.length === expectedLength) {
      setData({ ...data, bvn: phoneNumber });
      setErrorState({ ...errorState, bvn: '' });
    } else {
      setErrorState({ ...errorState, bvn: 'Invalid bvn' });
    }
  };
  function validateInput(input: any) {
    const pattern = /^@/; // Regex to check if the input starts with "@"
    if (pattern.test(input)) {
      setData({ ...data, company_email_structure: input });
      setErrorState({ ...errorState, email_structure: '' });

      return true;
    } else {
      setErrorState({ ...errorState, email_structure: 'Invalid input! It must start with @.' });

      return false;
    }
  }
  const validateAlternatePhoneNumber = (phoneNumber: string) => {
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    const expectedLength = 11;
    if (digitsOnly.length === expectedLength) {
      setData({ ...data, alternative_phone: phoneNumber });
      setErrorState({ ...errorState, alternative_phone: '' });
    } else {
      setErrorState({ ...errorState, alternative_phone: 'Invalid Phone Number' });
    }
  };
  const setOnChange = (e: any) => {
    if (e.target.name === 'phone_number') {
      validatePhoneNumber(e.target.value);
      return;
    }

    if (e.target.name === 'admin_name') {
      validateFullName(e.target.value);
      return;
    }

    if (e.target.name === 'company_email_structure') {
      validateInput(e.target.value);
      return;
    }

    if (e.target.name === 'alternative_phone') {
      validateAlternatePhoneNumber(e.target.value);
      return;
    }

    if (e.target.name === 'bvn') {
      validateBvn(e.target.value);
      return;
    }
    setData({ ...data, [e.target.name]: e.target.value });
  };
  // const [next] = useState('');
  const isFormComplete = areAllKeysFilled(data);

  const submitRegister = (e: { preventDefault: () => void; }) => {
    e.preventDefault();
    dispatch(handleRegisterRequest({ payload: data }));
    // setNext('otp');
  };
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(prevState => !prevState);
  };

  const submitEmployeeLogin = (e: { preventDefault: () => void; }) => {
    e.preventDefault();
    console.log(data);
    const payload = {
      email: employeeData.email,
    };
    dispatch(handleEmployeeEmailRequest({ payload: payload, navigate: navigate }));
  };

  useEffect(() => {
    dispatch(resetOtpState());
  }, []);
  return (
    <div>
      <div className='relative overflow-hidden' style={{ height: '90vh' }}>
        <div className='w-full hidden md:flex'>
          <HomeAbstract className='abstract'/>
        </div>
        <div className=' absolute top-0 h-screen flex flex-col items-center w-full'
          style={{ backgroundColor: '#0000000D' }}>
          <div
            className={`${next ? 'hidden' : ''} bg-white rounded-xl md:h-3/4 xl:h-fit md:w-6/12 lg:w-5/12 xl:w-4/12 w-11/12 overflow-auto border border-input-color my-8`}
            style={{ boxShadow: '0px 2px 8px 2px #8C8C8C1A' }}>
            <form autoComplete="off" className={`p-7 bg-white ${userData === 'admin' ? '' : 'hidden'}`}
                  onSubmit={submitRegister}>
              <div className="flex justify-between">
                <h3 className="font-semibold text-xl">
                  Register
                </h3>
              </div>
              <div className={'gap-3.5'}>
                <div className="py-4">
                  <label className="font-semibold text-sm block pb-2">
                    Company name
                  </label>
                  <div className="relative">
                    <CompanyNameIcon
                      className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
                    <input autoComplete="off" name="company_name" onChange={setOnChange} required
                           className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-custom"
                           type="text" placeholder="Enter your company name" />
                  </div>
                </div>
              </div>
              <div className="pb-3">
                <label className="font-semibold text-sm block pb-2">
                  Company address
                </label>
                <div className="relative">
                  <CompanyAddressIcon
                    className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
                  <input autoComplete="off" name="company_address" onChange={setOnChange} required
                         className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-custom"
                         type="text" placeholder="Enter your company address" />
                </div>
              </div>
              <div className="pb-3">
                <label className="font-semibold text-sm block pb-2">
                  Company email
                </label>
                <div className="relative">
                  <EmailIcon
                    className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
                  <input autoComplete="off" name="email" onChange={setOnChange} required
                         className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-custom"
                         type="email" placeholder="Email" />
                </div>
              </div>
              <div className="pb-3">
                <label className="font-semibold text-sm block pb-2">
                  Company email structure
                </label>
                <div className="relative">
                  <EmailIcon
                    className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
                  <input autoComplete="off" name="company_email_structure" onChange={setOnChange} required
                         className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-custom"
                         type="text" placeholder="Company email structure e.g @kekere.com" />
                </div>
                {errorState.email_structure && (
                  <div className="text-red-500 text-xs mt-1">
                    {errorState.email_structure}
                  </div>
                )}
              </div>
              <div className={'gap-3.5'}>
                <div className="pb-3">
                  <label className="font-semibold text-sm block pb-2">
                    Admin name (Last name and First name)
                  </label>
                  <div className="relative">
                    <UserIcon
                      className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
                    <input autoComplete="off" name="admin_name" onChange={setOnChange} required
                           className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-custom"
                           type="text" placeholder="Enter your admin name" />
                  </div>
                  {errorState.name && (
                    <div className="text-red-500 text-xs mt-1">
                      {errorState.name}
                    </div>
                  )}
                </div>
              </div>
              {/*<div className='pb-3'>*/}
              {/*  <label className='font-semibold text-sm block pb-2'>*/}
              {/*    Phone Number*/}
              {/*  </label>*/}
              {/*  <div className="relative">*/}
              {/*    <PhoneIcon*/}
              {/*      className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />*/}
              {/*    <input name='phone_number' value={data.phone_number} onChange={setOnChange} maxLength={11} required*/}
              {/*           className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-custom"*/}
              {/*           type="text" placeholder="Phone Number" />*/}
              {/*  </div>*/}
              {/*  {errorState.phone && (*/}
              {/*    <div className="text-red-500 text-xs mt-1">*/}
              {/*      {errorState.phone}*/}
              {/*    </div>*/}
              {/*  )}*/}
              {/*</div>*/}
              <div className="pb-3">
                <label className="font-semibold text-sm block pb-2">
                  Admin Email
                </label>
                <div className="relative">
                  <EmailIcon
                    className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
                  <input autoComplete="off" name="alternative_email" onChange={setOnChange} required
                         className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-custom"
                         type="email" placeholder="Admin Email" />
                </div>
              </div>
              <div className="pb-3">
                <label className="font-semibold text-sm block pb-2">
                  Bvn
                </label>
                <div className="relative">
                  <EmailIcon
                    className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
                  <input autoComplete="off" name="bvn" onChange={setOnChange} required
                         className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-custom"
                         type="text" placeholder="Enter bvn" />
                </div>
                {errorState.bvn && (
                  <div className="text-red-500 text-xs mt-1">
                    {errorState.bvn}
                  </div>
                )}
              </div>

              <div className="pb-3">
                <label className="font-semibold text-sm block pb-2">
                  Admin Phone Number
                </label>
                <div className="relative">
                  <PhoneIcon
                    className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
                  <input name="alternative_phone" type="text" placeholder="Alternative number" maxLength={11}
                         onChange={setOnChange} required autoComplete="off"
                         className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-custom"
                  />
                </div>
                {errorState.alternative_phone && (
                  <div className="text-red-500 text-xs mt-1">
                    {errorState.alternative_phone}
                  </div>
                )}
              </div>

              <div className="pb-3">
                <label className="font-semibold text-sm block pb-2">
                  Password
                </label>
                <div className="relative">
                  <PasswordIcon
                    className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
                  <input name="password" onChange={setOnChange} required
                         className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-custom"
                         type={isPasswordVisible ? 'text' : 'password'} placeholder="Password" />
                  <span
                    onClick={togglePasswordVisibility}
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
                  >
                    {isPasswordVisible ? <Eye size="20" color="#8E8E93" /> : <EyeSlash size="20" color="#8E8E93" />}
                  </span>
                </div>
              </div>
              <div className="flex justify-center">
                <CustomButton
                  isLoading={loading}
                  disabled={!isFormComplete}
                  children={'Register'}
                  className="w-6/12 bg-custom-darkgreen text-white font-semibold rounded-custom py-2"
                />
              </div>
              <div className="text-center py-3 text-xs">
                <p>Got an account? <Link to="/login"
                                         className="font-semibold text-custom-green">Login</Link></p>
              </div>
            </form>
            <form className={`w-full p-7 ${userData !== 'admin' ? 's' : 'hidden'}`} onSubmit={submitEmployeeLogin}>
              <div className="">
                <h3 className="font-semibold text-xl">
                  Create an account
                </h3>
                <p className={'text-xs text-custom-green'}>Enter Your Email Address </p>
              </div>
              <div className="pt-6 pb-4">
                <label className="font-semibold text-sm pb-2">
                  Email Address
                </label>
                <div className="relative">
                  <EmailIcon
                    className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
                  <input required onChange={(e) => validateRegisterEmail(e.target.value)}
                         className="text-xs focus-visible:outline-0 w-full p-2 pl-10 border border-input-color rounded-custom"
                         type="text" placeholder="Enter your email" />
                </div>
                {errorState.registerEmail && (
                  <p className="text-red-500 text-xs mt-1">{errorState.registerEmail}</p>
                )}
              </div>
              <div className='flex justify-center'>
                <CustomButton
                  isLoading={loading}
                  disabled={!employeeData.email}
                  children={'Continue'}
                  className='text-sm md:text-md w-1/2 pt-3 mt-3.5 bg-custom-darkgreen text-white font-semibold rounded-custom py-2'
                />
              </div>
              <div className='text-center py-3 text-xs'>
                <p>Already have an account?
                  <span
                        className='font-semibold cursor-pointer text-custom-green'> Log In</span>
                </p>
              </div>
            </form>
          </div>
          <OtpVerification email={data.email} next={next && employeeCreateSteps === 'email'} />
          {
            next && (
              <>
                <OtpLoginVerification email={employeeData.email} next={employeeCreateSteps} />
                <UpdateEmployee email={employeeData.email} next={employeeCreateSteps} />
              </>
            )
          }

        </div>
      </div>
    </div>
  );
}

export default CooperateSignUp;
